import "./styles.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import App from "./App";
import LandingPage from "./LandingPage";
import ExperimentSelect from "./ExperimentSelect";
import GuidedExperimentZnH2SO4 from "./components/guided/GuidedExperimentZnH2SO4";
import GuidedTitrationHClNaOH from "./components/guided/titration/GuidedTitrationHClNaOH";
import NaphthaleneExperiment from "./components/guided/naphthalene/NaphthaleneExperiment";
import SolubilityExperiment from "./components/guided/solubility/SolubilityExperiment";
import MagnesiumOxideExperiment from "./components/guided/magnesium-oxide/MagnesiumOxideExperiment";
import CopperOxideExperiment from "./components/guided/copper-oxide/CopperOxideExperiment";
import BalancedEquationsExperiment from "./components/guided/balanced-equations/BalancedEquationsExperiment";
import { AuthWrapper, SignInPage, SignUpPage, RoleSelectionPage, ProtectedRoute } from "./components/AuthComponents";
import TeacherDashboard from "./components/TeacherDashboard";
import TeacherExperimentStudents from "./components/TeacherExperimentStudents";
import TeacherExperimentSettings from "./components/TeacherExperimentSettings";
import StudentDashboard from "./components/StudentDashboard";
import StudentResults from "./components/StudentResults";
import CreateExperimentPage from "./components/CreateExperimentPage";
import NotFound from "./components/NotFound";
import { ErrorBoundaryWrapper } from "./components/ErrorBoundary";
import RequireWebGL from "./components/RequireWebGL";
import { ToastContainer } from "./components/ToastNotification";

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Root element not found");

const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <ErrorBoundaryWrapper>
      <AuthWrapper>
        <BrowserRouter>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/select" element={<ExperimentSelect />} />
            {/* 3D lab routes: need WebGL 2 */}
            <Route element={<RequireWebGL />}>
              <Route path="/play" element={<App />} />
              <Route path="/play/experiment/zinc-h2so4" element={<GuidedExperimentZnH2SO4 />} />
              <Route path="/play/experiment/titration-hcl-naoh" element={<GuidedTitrationHClNaOH />} />
              <Route path="/play/experiment/naphthalene" element={<NaphthaleneExperiment />} />
              <Route path="/play/experiment/solubility" element={<SolubilityExperiment />} />
              <Route path="/play/experiment/magnesium-oxide" element={<MagnesiumOxideExperiment />} />
              <Route path="/play/experiment/copper-oxide" element={<CopperOxideExperiment />} />
              <Route path="/play/experiment/balanced-equations" element={<BalancedEquationsExperiment />} />
            </Route>
            
            {/* Auth Routes - Updated according to Clerk docs */}
            <Route path="/sign-in" element={<SignInPage />} />
            <Route path="/sign-up" element={<SignUpPage />} />
            <Route path="/select-role" element={<RoleSelectionPage />} />

            {/* Teacher Routes (Protected) */}
            <Route path="/teacher/dashboard" element={
              <ProtectedRoute requiredRole="teacher">
                <TeacherDashboard />
              </ProtectedRoute>
            } />
            <Route path="/teacher/experiment/create" element={
              <ProtectedRoute requiredRole="teacher">
                <CreateExperimentPage />
              </ProtectedRoute>
            } />
            <Route path="/teacher/experiment/:id/students" element={
              <ProtectedRoute requiredRole="teacher">
                <TeacherExperimentStudents />
              </ProtectedRoute>
            } />
            <Route path="/teacher/experiment/:id/settings" element={
              <ProtectedRoute requiredRole="teacher">
                <TeacherExperimentSettings />
              </ProtectedRoute>
            } />

            {/* Student Routes (Protected) */}
            <Route path="/student/dashboard" element={
              <ProtectedRoute requiredRole="student">
                <StudentDashboard />
              </ProtectedRoute>
            } />
            <Route path="/student/results" element={
              <ProtectedRoute requiredRole="student">
                <StudentResults />
              </ProtectedRoute>
            } />

            {/* 404 Catch-All Route */}
            <Route path="*" element={<NotFound />} />
          </Routes>
          <ToastContainer />
        </BrowserRouter>
      </AuthWrapper>
    </ErrorBoundaryWrapper>
  </React.StrictMode>
);
